import { createRouter, createWebHistory } from 'vue-router'
import InputPage from '../views/InputPage.vue'
import ResultPage from '../views/ResultPage.vue'

const routes = [
  {
    path: '/',
    name: 'input',
    component: InputPage,
    props: true
  },
  {
    path: '/result/:requestId',
    name: 'result',
    component: ResultPage,
    props: route => ({
      requestId: route.params.requestId,
      cached: route.params.cached === 'true'
    })
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router